import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Trans } from "@lingui/macro";
import { withI18n } from "@lingui/react/cjs/react.production.min";
import withArrows from "../ProductsSlider/withArrows";
import ProductsSlider from "../ProductsSlider";
import useCurrentLanguage from "../../functions/languages/useCurrentLanguage";
import Attractions from "../Attractions";
import { SpinnerCircle } from "../Spinner";
import { Icon } from "../Icon";
import ProductCard from "../ProductCard";
import { getProductLink } from "../../functions/getProductLink";
import { getHref } from "../ProductsGrid";
import "./BestTours.css";

const ProductCarousel = withArrows(ProductsSlider);

export const BestTours = withI18n()(function BestTours({ cities }) {
  const lang = useCurrentLanguage();
  const currency = useSelector(state => state.currencies.defaultCurrency);
  const [selectedCityId, setSelectedCityId] = useState(cities[0]?.id || null);
  const [productsTours, setProductsTours] = useState([]);
  const [loading, setLoading] = useState(false);
  const productListId = `city_${selectedCityId}`;

  useEffect(() => {
    if (cities.length > 0) {
      setSelectedCityId(cities[0].id);
    }
  }, [cities]);

  useEffect(() => {
    const fetchProducts = async () => {
      if (selectedCityId) {
        const perPage = 12;
        const url = `/api/v2/products/popular/?city=${selectedCityId}&currency=${currency}&page=1&per_page=${perPage}&lang=${lang}&preorder=true&expand=description,images`;

        setLoading(true);
        try {
          const response = await fetch(url);
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          const data = await response.json();
          setProductsTours(data.data.results);
        } catch (error) {
          console.error("Error fetching products:", error);
        } finally {
          setLoading(false);
        }
      }
    };

    fetchProducts();
  }, [selectedCityId, currency, cities]);

  const handleCitySelect = cityId => {
    setSelectedCityId(cityId);
  };

  const itemsCount = productsTours.length;

  const selectParams = {
    cityId: selectedCityId,
    citySlug: cities.find(city => city.id === selectedCityId)?.slug,
  };

  return (
    <div className="Main__cities BestTours">
      <Attractions
        key="top-attractions"
        withHeading={false}
        attractions={cities}
        selectedAttractionId={selectedCityId}
        onSelect={handleCitySelect}
      />

      {loading ? (
        <SpinnerCircle className="Spinner--loading" size="large" theme="dark" />
      ) : (
        <div className="Wrapper__overload">
          <ProductCarousel
            arrowsMini
            flatOnMobile
            chainedScroll
            slidesPerPage={4}
            slidesToScroll={4}
            infinite={false}
            animationSpeed={500}
            title={
              <div className="ActivitiesSort__activities">
                <Icon name="found-flag" />
                <Trans>Activities found:</Trans>
                <span className="ActivitiesSort__activities-amount">{itemsCount}</span>
              </div>
            }
          >
            {[
              ...productsTours.map((product, i) =>
                product ? (
                  <div key={product.id}>
                    <ProductCard
                      key={product.id}
                      position={i}
                      link={getProductLink(lang, product)}
                      product={product}
                      listId={productListId}
                    />
                  </div>
                ) : null,
              ),
              <div key="placeholder" className="ProductsGrid__placeholder">
                <a
                  href={getHref(selectParams, lang)}
                  className="ProductsGrid__placeholder-card"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <div className="ProductsGrid__placeholder-content">
                    <Trans>See all</Trans>
                    <Icon name="chevron/right" />
                  </div>
                </a>
              </div>,
            ]}
          </ProductCarousel>
        </div>
      )}
    </div>
  );
});
